import ContactChangeModal from "./ContactChangeModal";
import { useConfig } from "../../context/config-context";

// Format email : partie locale @ domaine . extension (2 lettres min), sans espace
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;

/**
 * UpdateEmailModal - Modale pour modifier l'adresse email du prescripteur
 * Un code de vérification est envoyé à la nouvelle adresse avant toute modification.
 */
export default function UpdateEmailModal({ currentEmail, onSuccess }) {
  const siteConfig = useConfig();

  const validateEmail = (value) => {
    const email = (value || "").trim().toLowerCase();
    if (!EMAIL_REGEX.test(email)) return siteConfig.components.email.invalid;
    if (email === (currentEmail || "").toLowerCase()) {
      return "Cet email est identique à votre email actuel";
    }
    return true;
  };

  return (
    <ContactChangeModal
      type="email"
      icon={siteConfig.medias.mail_svg}
      title="Modifier l’email"
      currentLabel="Email"
      currentValue={currentEmail}
      newLabel="Nouvel email"
      placeholder="exemple@mail.com"
      inputType="email"
      inputProps={{ autoComplete: "email", maxLength: 254 }}
      rules={{
        required: siteConfig.components.email.required,
        validate: validateEmail,
      }}
      isValid={(value) => validateEmail(value) === true}
      onSuccess={onSuccess}
    />
  );
}
